/**
 * Canonical statement ordering for the redesigned Audited Financials page
 * (RECUR-27010): Balance Sheet -> Profit & Loss -> Cash Flow, stacked as
 * collapsible sections regardless of the order `fetchMisTableOptions` returns.
 *
 * Matched against the backend's `misDisplayName` options by keyword rather than
 * an exact string — the exact display string is backend-owned data (see
 * AicaPDFReport.tsx using 'Profit And Loss' vs the tab options historically
 * showing other variants) and this component must not hardcode it.
 */
export type AuditedStatementKey = 'balanceSheet' | 'profitAndLoss' | 'cashFlow';

export const AUDITED_STATEMENT_CONFIGS: { key: AuditedStatementKey; matcher: RegExp }[] = [
    { key: 'balanceSheet', matcher: /balance\s*sheet/i },
    { key: 'profitAndLoss', matcher: /profit/i },
    { key: 'cashFlow', matcher: /cash/i },
];

/** Section-header fallback shown only until `fetchMisTableOptions` resolves the real name. */
export const AUDITED_STATEMENT_FALLBACK_LABELS: Record<AuditedStatementKey, string> = {
    balanceSheet: 'Balance Sheet',
    profitAndLoss: 'Profit & Loss',
    cashFlow: 'Cash Flow',
};
